import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import Aplicacion from "./Aplicacion";

import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Aplicacion />
    </BrowserRouter>
  </HelmetProvider>
);
